import gql from 'graphql-tag';

/**
 * The mutation to log in the user.
 */
export const LoginMutation = gql`
  mutation login {
    login {
      id
    }
  }
`;

export type LoginResponse = {
  login: {
    id: string;
  };
};

/**
 * The mutation to log the user.
 */
export const LogoutMutation = gql`
  mutation logout {
    logout
  }
`;

export type LogoutResponse = {
  logout: LogoutRequestStatus;
};

export enum LogoutRequestStatus {
  ERROR = 'ERROR',
  OK = 'OK',
}
